import request from '@/utils/request'

export function getWaterMarkList (params) {
  return request({
    url: '/v2/sec/contractAdmin/getWaterMarkList',
    method: 'post',
    data: params
  })
}
export function deleteWaterMark (params) {
  return request({
    url: '/v2/sec/contractAdmin/deleteWaterMark',
    method: 'post',
    data: params
  })
}
export function getSettingContract (params) {
  return request({
    url: '/v2/sec/contractAdmin/getSettingContract',
    method: 'post',
    data: params
  })
}
export function setSettingCheckList (params) {
  return request({
    url: '/v2/sec/contractAdmin/setSettingCheckList',
    method: 'post',
    data: params
  })
}
export function setMetaStr (params) {
  return request({
    url: '/v2/sec/contractAdmin/setMetaStr',
    method: 'post',
    data: params
  })
}
export function uploadWaterMark (data) {
  return request({
    url: '/v2/sec/contractAdmin/upload',
    method: 'post',
    data
  })
}
